import { render } from "./Vitrine.vue?vue&type=template&id=708051d6&scoped=true"
import script from "./Vitrine.vue?vue&type=script&lang=js"
export * from "./Vitrine.vue?vue&type=script&lang=js"

import "./Vitrine.css?vue&type=style&index=0&id=708051d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708051d6"]])

export default __exports__